import React, { Component } from 'react';
import { Modal, Spin, message } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import $ from 'jquery';

class MatchReturned extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        record: {},
        selectedRowKeys: [],
    }

    loadData = () => {
        const { record: { contractRemittanceApplicationId } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.selectContractBackRecordList, {
            contractRemittanceApplicationId,
        }).then(res => {
            const data = res.data || [];
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record) => {
        const { manualRecords } = record;
        const selectedRowKeys = (manualRecords || []).map(i => i.contractBackRecordId);
        this.setState({
            record,
            data: [],
            visible: true,
            selectedRowKeys,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false }, () => {
            $('.tableC .transferCompany .ant-table-body').scrollTop(0);
        });
    }

    getColumns = () => [{
        title: '发票日期',
        dataIndex: 'invoiceDate',
        key: 'invoiceDate',
        width: 80,
    }, {
        title: '发票号',
        dataIndex: 'remark',
        key: 'remark',
        width: 100,
    }, {
        title: 'JDE主项目号',
        dataIndex: 'jdeMainCode',
        key: 'jdeMainCode',
        width: 100,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 160,
    }, {
        title: '客户名称',
        dataIndex: 'alphaname',
        key: 'alphaname',
        width: 120,
    }, {
        title: '发票描述(包含Milstone和PT非PT)',
        dataIndex: 'reference',
        key: 'reference',
        width: 120,
    }, {
        title: '发票金额(含税总额)总金额',
        dataIndex: 'grossAmount',
        key: 'grossAmount',
        width: 100,
        render: text => format('money', text),
    }, {
        title: '确认收款金额',
        dataIndex: 'receivingAmount',
        key: 'receivingAmount',
        width: 100,
        render: text => format('money', text),
    }, {
        title: '收款日期',
        dataIndex: 'dateInvoiceClosed',
        key: 'dateInvoiceClosed',
        width: 80,
    }]

    onSelectChange = (record, selected) => {
        const { contractBackRecordId } = record;
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            list.push(contractBackRecordId);
        } else {
            list = list.filter(i => i != contractBackRecordId);
        }
        this.setState({ selectedRowKeys: list });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            changeRows.forEach(i => {
                list.push(i.contractBackRecordId);
            });
        } else {
            list = [];
        }
        this.setState({ selectedRowKeys: list });
    }

    handleSelectChange = (value) => {
        this.setState({ userId: value });
    }

    submit = () => {
        const { record, selectedRowKeys } = this.state;
        const { contractRemittanceApplicationId } = record;
        const params = {};
        (selectedRowKeys || []).forEach((id, index) => params[`ids[${index}]`] = id);

        this.setState({ loading: true });
        Fetch.post(API_URL.contract.saveContractBackRecordList, {
            contractRemittanceApplicationId,
            ...params
        }).then(res => {
            message.success(res.success);
            this.setState({ loading: false }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible, loading, data, record, selectedRowKeys } = this.state;
        const { investigationJdeContractCode } = record;
        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
        };
        return (
            <Modal
                title="匹配回款"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 500 }}
                width="1200px"
            >
                <Spin spinning={loading}>
                    <p style={{marginBottom: 10}}>JDE项目号：{investigationJdeContractCode}</p>
                    <TableC
                        scrollY={360}
                        data={data}
                        columns={this.getColumns()}
                        rowKey="contractBackRecordId"
                        rowSelection={rowSelection}
                    />
                </Spin>
            </Modal>
        );
    }
}


export default MatchReturned;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/MatchReturned.js